import { render, staticRenderFns } from "./DataGroup.vue?vue&type=template&id=de0bad82&"
import script from "./DataGroup.vue?vue&type=script&lang=js&"
export * from "./DataGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports